import { __rest } from "tslib";
import { BiasType } from '../models/attribute.model';
import { SearchForRetail } from '@/constants';
export const parseBiasingStrategy = (_a) => {
    var { biases, name } = _a, model = __rest(_a, ["biases", "name"]);
    return (Object.assign(Object.assign({}, model), { name, defineBiasItems: parseDefineBiasItems(biases) }));
};
const parseNumericContent = (numericContent) => {
    if (!numericContent)
        return [];
    const numericContents = [];
    const { ranges, values } = numericContent;
    if (values) {
        numericContents.push({ values });
    }
    if ((ranges === null || ranges === void 0 ? void 0 : ranges.length) > 0) {
        ranges.forEach((range) => numericContents.push({ ranges: [range] }));
    }
    return numericContents;
};
const convertBiasTypeToAttributeType = (type) => {
    if (!type)
        return '';
    switch (type) {
        case BiasType.Numeric:
            return 'NUMERICAL';
        case BiasType.Textual:
            return 'TEXTUAL';
        default:
            return '';
    }
};
export const parseDefineBiasItems = (defineItems) => defineItems.map(({ field, type, content, strength, numericContent, }) => ({
    type: convertBiasTypeToAttributeType(type),
    attributeName: field,
    matches: content || '',
    influenceSliderValue: SearchForRetail.BiasingStrategyStrength[strength],
    numericContents: parseNumericContent(numericContent),
}));
